import { db, storageRef } from "../firebase/config";

import path from "path";

const uploadProfileImage = (userID: string, file: File) => {
  const extension = path.extname(file.name);
  storageRef
    .child(`profiles/${userID}/image${extension}`)
    .put(file)
    .then(async (snapshot) => {
      const url = await snapshot.ref.getDownloadURL();

      db.collection("profiles").doc(userID).set(
        {
          image: url,
        },
        { merge: true }
      );
    })
    .catch((error) => console.error(error));
};

export default uploadProfileImage;
